import { AddRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { DefaultLayout } from '@layouts';
import { NextSeo } from 'next-seo';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { stringify } from 'qs';
import React from 'react';
import {
  ContentBlockCard,
  Header,
  Hero,
  Section,
} from '@components';

const Camere = ({ service }) => {
  const { name, hero, introduction, content_block } = service;
  return (
    <>
      <NextSeo
        title={`Momento | ${hero?.title}`}
        description={hero?.description}
      />

      <DefaultLayout
        header={
          <Hero
            isHero
            label={hero?.label}
            title={hero?.title}
            description={hero?.description}
            hasSlider={hero?.media?.data?.length > 0}
            slides={hero?.media?.data?.map(({ attributes }) => {
              return {
                img: attributes,
              };
            })}
          />
        }
      >
        <div className="pt-16 sm:pt-0"></div>

        <Section>
          <Header
            title={introduction?.title}
            label={introduction?.label}
            description={introduction?.description}
          />
          <div className="space-y-16">
            {content_block?.map((block, index) => {
              const { media, title, description, subtitle, cta } =
                block;
              return (
                <ContentBlockCard
                  key={index}
                  img={
                    media?.data.length > 1
                      ? media?.data
                      : media?.data[0]?.attributes
                  }
                  index={index}
                >
                  <p className="h2 text-primary">{title}</p>
                  <p className="label">{subtitle}</p>
                  <p className="body max-w-[90%]">{description}</p>
                  {cta && (
                    <Button href={cta?.href ?? '/'}>
                      <AddRounded className="mr-1" />{' '}
                      <span>{cta?.label}</span>
                    </Button>
                  )}
                </ContentBlockCard>
              );
            })}
          </div>
        </Section>
        <div className="h-20"></div>
      </DefaultLayout>
    </>
  );
};

export default Camere;
export async function getServerSideProps({ params, locale }) {
  const path = process.env.NEXT_PUBLIC_STRAPI; // process.env.NEXT_PUBLIC_STRAPI;
  const qs = stringify(
    {
      populate: [
        'hero',
        'hero.media',
        'introduction',
        'content_block',
        'content_block.media',
        'content_block.cta',
      ],
      filters: {
        slug: { $eq: 'le-camere' },
      },

      locale: locale,
    },
    {
      encodeValuesOnly: true, // prettify URL
    },
  );
  const getProdData = await fetch(
    `${path}/accommodation-services?${qs}`,
  );

  const product = await getProdData.json();

  if (product.data[0]) {
    return {
      props: {
        service: product.data[0]?.attributes,
        ...(await serverSideTranslations(locale, ['common'])),
        path: `${path}/accommodation-services?${qs}`,
      },
    };
  }
  return {
    props: {
      service: {},
    },
  };
}
